import { render, staticRenderFns } from "./PersonAuthern.vue?vue&type=template&id=37fef789&scoped=true&"
import script from "./PersonAuthern.vue?vue&type=script&lang=ts&"
export * from "./PersonAuthern.vue?vue&type=script&lang=ts&"
import style0 from "./PersonAuthern.vue?vue&type=style&index=0&id=37fef789&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fef789",
  null
  
)

export default component.exports